export const initialLogInData = {
    email: "",
    password: ""
  };
  export const initialSignUpData = {
    firstName: "",
    lastName: "",
    email: "",
    password: ""
  };
  export const guestData = {
    email: "test1234@gmail.com",
    password: "test1234"
  };
  